'use client';

import TalkToBriModalTrigger from '@/components/voice/TalkToBriModalTrigger';

/**
 * "Talk to Bri" entry in the footer's Product column. A client island (the
 * `Footer` stays a Server Component) styled to match the surrounding
 * `<Link>` list items exactly — same class hook + sizing — but rendered as
 * a `<button>` since it opens the shared voice modal rather than navigating.
 */
export function TalkToBriFooterLink() {
  return (
    <TalkToBriModalTrigger source="navbar">
      {(open) => (
        <button
          type="button"
          onClick={open}
          aria-haspopup="dialog"
          data-testid="talk-to-bri-footer-link"
          className="v4-footer-link"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            fontSize: 14,
            minHeight: 44,
            color: 'var(--paper)',
            textDecoration: 'none',
            transition: 'color 0.2s ease',
            background: 'transparent',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            textAlign: 'left',
          }}
        >
          Talk to Bri
        </button>
      )}
    </TalkToBriModalTrigger>
  );
}

export default TalkToBriFooterLink;
